import { render, staticRenderFns } from "./DedicateData.vue?vue&type=template&id=733ea064&"
import script from "./DedicateData.vue?vue&type=script&lang=js&"
export * from "./DedicateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports